import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthService } from 'src/app/services/auth.service';
import { Vaga } from 'src/app/services/vaga.model';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-processing',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss']
})
export class ProcessingComponent implements OnInit {

  bShowProcessing: boolean = true;
  bProcessing: boolean = true;
  bWinner: boolean = false;
  bReserved: boolean = false;
  vagaEscolhida: Vaga;

  constructor(
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private dataService: DataService,
    private router: Router,
    public auth: AuthService) { }

  ngOnInit() {
  
    // Verifica se já escolhei alguma vaga
    this.afs.collection('vagas', ref => ref.where("user", "==", this.afAuth.auth.currentUser.uid)).snapshotChanges().subscribe(data => {
      
      let arrInscricoes = data.map(e => {
        return {
          id: e.payload.doc.id
        }
      })

      // Se já tem uma inscrição
      if (arrInscricoes.length > 0)
      {
        this.Processa(arrInscricoes[0].id);
      }
      else
      {
        this.Processa();
      }

    });
  }

  private Processa(uid = null) {

    setTimeout(() => {
      
      // Coleta o UID
      let uidTmp = (uid) ? uid : this.dataService.Get_Vaga().uid

      // Coleta a ref da vaga
      const vagaDoc : AngularFirestoreDocument<Vaga> = this.afs.doc<Vaga>(`vagas/${uidTmp}`);

      vagaDoc.get().toPromise().then((querySnapshot) => {
        
        // Recebe os valores
        let vaga  = querySnapshot.data();
        this.vagaEscolhida = vaga as Vaga;
        
        // Retira processamento
        this.bProcessing = false;
        
        // Verifica se tem cupom
        if (vaga.cupom != null) {
          this.bWinner = true;
        }
        else
        {
          this.bReserved = true;
        }

        // Atualiza vaga
        vaga.disponivel = false;
        vaga.user       = this.afAuth.auth.currentUser.uid;
        vaga.photoURL   = this.afAuth.auth.currentUser.photoURL;

        vagaDoc.update(vaga);
      });

    }, 4500);
  }

  Fechar() {
    // Redireciona
    this.router.navigate(['/']);
  }
}